/* 🤖 this file was generated by svg-to-ts */
export const matIconMemory: {
  name: 'memory';
  data: string;
} = {
  name: 'memory',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"/></svg>`
};
